import { BROADCAST_EVENT_KIND, broadcastCta, broadcastEyebrow, broadcastLink, broadcastLinkHost, broadcastNeedsContent, broadcastTakesLink, isBroadcastType, safeBroadcastUrl, } from "@healthos/shared";
/** The modal a broadcast renders as on every client, or null for any other event. */
export function broadcastModalProps(event) {
    if (event.kind !== BROADCAST_EVENT_KIND)
        return null;
    const type = event.data?.broadcastType;
    if (!isBroadcastType(type))
        return null;
    return composeBroadcastModal({
        momentId: event.id,
        type,
        title: event.title ?? "",
        body: event.body ?? "",
        contentId: typeof event.data?.contentId === "string" ? event.data.contentId : null,
        contentTitle: typeof event.data?.contentTitle === "string" ? event.data.contentTitle : null,
        linkUrl: typeof event.data?.linkUrl === "string" ? event.data.linkUrl : null,
        linkLabel: typeof event.data?.linkLabel === "string" ? event.data.linkLabel : null,
    });
}
/** Also used for the admin preview, so the preview is the modal the member gets. */
export function composeBroadcastModal(input) {
    const { linkUrl: rawUrl, linkLabel, ...rest } = input;
    const linked = broadcastNeedsContent(input.type) && input.contentId;
    const url = broadcastTakesLink(input.type) ? safeBroadcastUrl(rawUrl) : null;
    return {
        ...rest,
        eyebrow: `Heartbeat · ${broadcastEyebrow(input.type)}`,
        cta: url ? linkLabel?.trim() || "Open link" : broadcastCta(input.type),
        target: url ?? (linked ? broadcastLink(input.type, input.contentId) : null),
        external: url !== null,
        linkHost: url ? broadcastLinkHost(url) : null,
    };
}
/**
 * What a broadcast's primary tap does, on the analytics microstep action set.
 * Shared so web and mobile report the same tap the same way.
 */
export function broadcastPrimaryAction(broadcast) {
    if (!broadcast.target)
        return "complete";
    if (broadcast.external)
        return "navigate";
    if (broadcast.type === "reset")
        return "play_reset";
    if (broadcast.type === "article")
        return "open_content";
    return "navigate";
}
//# sourceMappingURL=broadcast-modal.js.map